import React from 'react';

export default (props?: any) => {
   const { text, disabled, onClick} = props;
   return (
      <button className="btn-container" disabled={disabled} onClick={onClick}>
         {text}
      </button>
   )
}